<template>
  <div>
    <b-loading :is-full-page="true" :active.sync="isLoading"> </b-loading>
    <div class="block icon-div">
      <b-icon
        icon="information-outline"
        size="is-medium"
        type="is-info"
      ></b-icon>
      This view is readonly. Any edits/updates on Proposition 65 Compliance
      Items need to be done in Supplier Exchange
    </div>
    <div class="prop65-btn-wrapper">
      <b-button type="is-info" @click="downloadProp65">Download Data</b-button>
      <!-- <b-upload
        class="upload-prop65"
        v-model="prop65UploadFile"
        type="is-info"
        @input="uploadProp65"
      >
        <a
          class="button is-info"
          title="This process can take up to 10 minutes when the number of records are 1000 or more."
        >
          <span>Upload Data</span>
        </a>
      </b-upload>
      <b-button type="is-info" @click="submitProp65" :disabled="lineErrors > 0"
        >Submit</b-button
      > -->
    </div>
    <div class="pagination-wrapper">
      <div class="pagination-header">
        <b-button
          v-show="showPreviousButton"
          @click="
            pageIndex = pageIndex - 1;
            getProp65ComplianceItems();
          "
          >Previous</b-button
        >
        <b-button
          v-show="showFirstButton"
          @click="
            pageIndex = 1;
            getProp65ComplianceItems();
          "
          >First</b-button
        >
        <span class="page-index"
          >{{ minPageIndex }} to {{ maxPageIndex }} of {{ totalResults }}</span
        >
        <b-button
          v-show="showLastButton"
          @click="
            pageIndex = totalPages;
            getProp65ComplianceItems();
          "
          >Last</b-button
        >
        <b-button
          v-show="showNextButton"
          @click="
            pageIndex = pageIndex + 1;
            getProp65ComplianceItems();
          "
          >Next</b-button
        >
        <span class="page-navigator" v-show="totalResults > 10"
          ><span class="show-text">Show</span
          ><b-select
            class="page-display-number"
            v-model="numberOfItemsPerPage"
            @input="
              pageIndex = Math.floor(minPageIndex / numberOfItemsPerPage) + 1;
              getProp65ComplianceItems();
            "
            ><option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </b-select></span
        >
      </div>
    </div>
    <div class="prop65-compliance-items-table-wrapper">
      <table>
        <thead>
          <tr>
            <th>Line No.</th>
            <th
              v-for="headerName in prop65ComplianceItemsColumns"
              :key="headerName.id"
              :title="headerName"
            >
              <label>{{ headerName }}</label>
            </th>
          </tr>
        </thead>
        <tbody class="prop65-compliance-items-body viewOnly">
          <tr
            v-for="(row, index) in prop65ComplianceItemsData"
            :key="row.id"
            @click="onRowClick($event)"
            @change="
              !isLoading ? changeOnProp65ComplianceItem($event, index, row) : ''
            "
            v-bind="row"
          >
            <ValidationObserver>
              <td>
                <b-input
                  type="text"
                  :value="row.lineNumber"
                  :title="row.lineNumber"
                  class="lineNumber"
                  disabled
                >
                </b-input>
              </td>
              <td>
                <ValidationProvider
                  rules="required"
                  :bails="false"
                  v-slot="{ classes }"
                  immediate
                >
                  <div class="control" :class="classes">
                    <b-input
                      type="text"
                      :value="row.vn"
                      :title="row.vn"
                      class="vn"
                      disabled
                    >
                    </b-input>
                  </div>
                </ValidationProvider>
              </td>
              <td>
                <ValidationProvider
                  rules="required"
                  :bails="false"
                  v-slot="{ classes }"
                  immediate
                  vid="prop65"
                >
                  <div class="control" :class="classes">
                    <b-select class="prop65" v-model="row.prop65">
                      <option value="Y">Yes</option>
                      <option value="N">No</option>
                    </b-select>
                  </div>
                </ValidationProvider>
              </td>
              <td>
                <ValidationProvider
                  rules="required_if:prop65,Y"
                  :bails="false"
                  v-slot="{ classes }"
                  immediate
                >
                  <div class="control" :class="classes">
                    <b-select class="prop65Detail" v-model="row.prop65Haz">
                      <option value="Carcinogen Hazard"
                        >Carcinogen Hazard</option
                      >
                      <option value="Reproductive Hazard"
                        >Reproductive Hazard</option
                      >
                      <option value="Both">Both</option>
                    </b-select>
                  </div>
                </ValidationProvider>
              </td>
              <td>
                <ValidationProvider
                  rules="required_if:prop65,Y"
                  :bails="false"
                  v-slot="{ classes }"
                  immediate
                >
                  <div class="control" :class="classes">
                    <b-input
                      class="fcat"
                      type="text"
                      :value="row.fcat"
                      :title="row.fcat"
                      disabled
                    >
                    </b-input>
                  </div>
                </ValidationProvider>
              </td>
              <td>
                <ValidationProvider
                  rules="required_if:prop65,Y"
                  :bails="false"
                  v-slot="{ classes }"
                  immediate
                >
                  <div class="control" :class="classes">
                    <b-input
                      class="vcat"
                      type="text"
                      :value="row.vcat"
                      :title="row.vcat"
                      disabled
                    >
                    </b-input>
                  </div>
                </ValidationProvider>
              </td>
              <td>
                <b-input
                  class="cc"
                  type="text"
                  :value="row.controlCode"
                  :title="row.controlCode"
                  disabled
                >
                </b-input>
              </td>
              <td v-on:keypress="typeAheadTriggered = 'cancerChemName'">
                <v-select
                  :filterable="false"
                  :options="cancerChemicalNameOptions"
                  class="cancerChemName"
                  v-model="row.cancerChemicalName"
                  :class="
                    row.prop65 === 'Y' &&
                    row.prop65Haz === 'Carcinogen Hazard' &&
                    (row.cancerChemicalName === undefined ||
                      row.cancerChemicalName === '' ||
                      row.cancerChemicalName === null)
                      ? 'is-danger'
                      : ''
                  "
                  :disabled="
                    row.prop65 === ' ' ||
                      row.prop65 === 'N' ||
                      row.prop65Haz === '' ||
                      row.prop65Haz === 'Reproductive Hazard'
                  "
                  @input="changeOnProp65ComplianceItem($event, index, row)"
                  @search="fetchCancerChemicalName"
                  :title="row.cancerChemicalName"
                >
                  <template slot="option" slot-scope="cancerChemicalNameOption">
                    <div class="d-center">
                      {{ cancerChemicalNameOption.label }}
                    </div>
                  </template>
                  <template
                    slot="selected-option"
                    slot-scope="cancerChemicalNameOption"
                    title="cancerChemicalNameOption"
                  >
                    <div class="selected d-center">
                      {{ cancerChemicalNameOption.label }}
                    </div>
                  </template>
                  <template
                    slot="no-options"
                    slot-scope="{ search, searching }"
                  >
                    <template v-if="searching">
                      Sorry, no matching options.
                    </template>
                    <span v-else class="display-none"></span>
                  </template>
                </v-select>
              </td>
              <td v-on:keypress="typeAheadTriggered = 'repChemicalName'">
                <v-select
                  :filterable="false"
                  :options="repChemicalNameOptions"
                  class="repChemName"
                  v-model="row.repChemicalName"
                  :class="
                    row.prop65 === 'Y' &&
                    row.prop65Haz === 'Reproductive Hazard' &&
                    (row.repChemicalName === undefined ||
                      row.repChemicalName === '' ||
                      row.repChemicalName === null)
                      ? 'is-danger'
                      : ''
                  "
                  :disabled="
                    row.prop65 === ' ' ||
                      row.prop65 === 'N' ||
                      row.prop65Haz === '' ||
                      row.prop65Haz === 'Carcinogen Hazard'
                  "
                  @input="changeOnProp65ComplianceItem($event, index, row)"
                  @search="fetchRepChemicalName"
                  :title="row.repChemicalName"
                >
                  <template slot="option" slot-scope="repChemicalNameOption">
                    <div class="d-center">
                      {{ repChemicalNameOption.label }}
                    </div>
                  </template>
                  <template
                    slot="selected-option"
                    slot-scope="repChemicalNameOption"
                    title="repChemicalNameOption"
                  >
                    <div class="selected d-center">
                      {{ repChemicalNameOption.label }}
                    </div>
                  </template>
                  <template
                    slot="no-options"
                    slot-scope="{ search, searching }"
                  >
                    <template v-if="searching">
                      Sorry, no matching options.
                    </template>
                    <span v-else class="display-none"></span>
                  </template>
                </v-select>
              </td>
              <td>
                <b-input
                  class="cancerCASNbr"
                  :class="
                    row.prop65 === 'Y' &&
                    row.prop65Haz === 'Carcinogen Hazard' &&
                    (row.cancerCasNbr === undefined ||
                      row.cancerCasNbr === '' ||
                      row.cancerCasNbr === null)
                      ? 'is-danger'
                      : ''
                  "
                  type="text"
                  :value="row.cancerCasNbr"
                  @change.native="row.cancerCasNbr = $event.target.value"
                  :title="row.cancerCasNbr"
                >
                </b-input>
              </td>
              <td>
                <b-input
                  class="repCASNbr"
                  :class="
                    row.prop65 === 'Y' &&
                    row.prop65Haz === 'Reproductive Hazard' &&
                    (row.repCasNbr === undefined ||
                      row.repCasNbr === '' ||
                      row.repCasNbr === null)
                      ? 'is-danger'
                      : ''
                  "
                  type="text"
                  :value="row.repCasNbr"
                  @change.native="row.repCasNbr = $event.target.value"
                  :title="row.repCasNbr"
                >
                </b-input>
              </td>
              <td>
                <ValidationProvider
                  rules="required"
                  :bails="false"
                  v-slot="{ classes }"
                  immediate
                >
                  <div class="control" :class="classes">
                    <b-select
                      class="lblCompliance"
                      v-model="row.labelingCompliance"
                    >
                      <option value="Y">Yes</option>
                      <option value="N">No</option>
                    </b-select>
                  </div>
                </ValidationProvider>
              </td>
              <!-- <td>
                <b-input
                  class="createdBy"
                  type="text"
                  :value="row.createdBy"
                  :title="row.createdBy"
                  disabled
                >
                </b-input>
              </td>
              <td>
                <b-input
                  class="updatedBy"
                  type="text"
                  :value="row.updatedBy"
                  :title="row.updatedBy"
                  disabled
                >
                </b-input>
              </td> -->
            </ValidationObserver>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import BSelect from "buefy/src/components/select/Select";
import BInput from "buefy/src/components/input/Input";
import { extend } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import vSelect from "vue-select";

extend("required", {
  validate(value) {
    return {
      required: true,
      valid: [" ", "", null, undefined, 0].indexOf(value) === -1
    };
  },
  computesRequired: true
});

extend("valOfAu", {
  params: ["suVal"],
  validate: (value, { suVal }) => {
    if (
      (suVal === "PK" && value === " ") ||
      (suVal === "PK" && value === "CS")
    ) {
      return true;
    } else if (suVal !== "PK") {
      return true;
    }
  }
});

extend("isPcValid", {
  params: ["mcsVal"],
  validate: (value, { mcsVal }) => {
    if (mcsVal.charAt(0) === "A") {
      if (value.startsWith("07")) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }
});

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

export default {
  name: "ErroredMainframeItemsComponent.vue",
  components: { BSelect, BInput, vSelect },
  data() {
    return {
      pageIndex: 1,
      minPageIndex: "",
      maxPageIndex: "",
      totalResults: "",
      totalPages: "",
      showPreviousButton: true,
      showNextButton: true,
      showFirstButton: true,
      showLastButton: true,
      numberOfItemsPerPage: 10,
      prop65ComplianceItemsFilter: "",
      isLoading: false,
      prop65ComplianceItemsColumns: [
        "Vendor Number",
        "Proposition 65",
        "Proposition 65 Detail",
        "Fisher Catalog Number",
        "Supplier Catalog Number",
        "Control Code",
        "Cancer Chemical Name",
        "Reproductive Chemical Name",
        "Cancer CAS Number",
        "Reproductive CAS Number",
        "Labeling Compliance"
        // "Created By",
        // "Updated By"
      ],
      prop65ComplianceItemsData: [],
      prop65UploadFile: null,
      lineErrors: "",
      cancerChemicalNameOptions: [],
      repChemicalNameOptions: [],
      typeAheadTriggered: ""
    };
  },
  mounted() {
    this.getProp65ComplianceItems();
  },
  watch: {},
  props: ["reloadErroredItems"],
  methods: {
    changeOnProp65ComplianceItem(event, index, rowData) {
      var rowArrayFromResponse = JSON.parse(
        sessionStorage.getItem("prop65Rows")
      );
      if (rowArrayFromResponse && rowArrayFromResponse.length > 0) {
        var rowDataFromResponseObj = JSON.parse(
          sessionStorage.getItem("prop65Rows")
        )[index];
        for (var key in (rowDataFromResponseObj, rowData)) {
          if (
            key !== "lineNumber" &&
            rowDataFromResponseObj[key] !== rowData[key]
          ) {
            if (
              !(
                rowDataFromResponseObj[key] === undefined &&
                rowData[key] === " "
              )
            ) {
              if (rowData[key] === " ") {
                rowData[key] = "";
              }
              rowData.updatedBy = window.$cookies.get("ni_key").nameUser;
              this.updateProp65Items(index, rowData);
              break;
            }
          }
        }
      }
    },
    downloadProp65() {
      var scope = this;
      var url = "";
      var filename = "";
      url = `${process.env.VUE_APP_API_BASE_DOMAIN}prop65/downloadItems`;
      filename = "Propsotition 65 Existing Items.xlsx";
      scope.isLoading = true;
      scope
        .$http({
          url: url,
          method: "GET",
          responseType: "blob"
        })
        .then(function(response) {
          scope.isLoading = false;
          var url = window.URL.createObjectURL(new Blob([response.data]));
          var link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          scope.isLoading = false;
          scope.$buefy.dialog.alert({
            message: `A problem occurred with file download. Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            confirmText: "OK",
            type: "is-danger"
          });
        });
    },
    fetchCancerChemicalName(search, loading) {
      this.typeAheadTriggered = "cancerChemicalName";
      this.fetchTypeAhead(search, loading);
    },
    fetchRepChemicalName(search, loading) {
      this.typeAheadTriggered = "repChemicalName";
      this.fetchTypeAhead(search, loading);
    },
    fetchTypeAhead(search, loading) {
      if (search.length > 0) {
        var scope = this;
        var field = "";

        loading(true);
        scope.$http
          .post(
            `${process.env.VUE_APP_API_BASE_DOMAIN}getChemCategoryNames/chemical`,
            { name: search }
          )
          .then(function(response) {
            loading(false);
            switch (scope.typeAheadTriggered) {
              case "cancerChemicalName":
                scope.cancerChemicalNameOptions = response.data;
                break;
              case "repChemicalName":
                scope.repChemicalNameOptions = response.data;
                break;
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch(function(error) {
            loading(false);
            scope.$buefy.dialog.alert({
              message: `Failed to load matching results. Please enter valid search criteria and/or clear the cache and try again. If the problem persists, please contact the New Item Support at NewItem.IT.Support@thermofisher.com`,
              confirmText: "OK",
              type: "is-danger"
            });
          });
      }
    },
    getProp65ComplianceItems() {
      var scope = this;
      scope.isLoading = true;
      scope.$http
        .get(
          `${process.env.VUE_APP_API_BASE_DOMAIN}prop65/retrieveMFProp65Data?pageNbr=${scope.pageIndex}&pageSize=${scope.numberOfItemsPerPage}`
        )
        .then(function(response) {
          scope.isLoading = false;
          response.data.startIndex
            ? (scope.minPageIndex = response.data.startIndex)
            : (scope.minPageIndex = 0);
          response.data.endIndex
            ? (scope.maxPageIndex = response.data.endIndex)
            : (scope.maxPageIndex = 0);
          response.data.totalCount
            ? (scope.totalResults = response.data.totalCount)
            : (scope.totalResults = 0);
          response.data.totalPages !== undefined
            ? (scope.totalPages = response.data.totalPages)
            : (scope.totalPages = 0);
          if (response.data.startIndex <= 1) {
            scope.showPreviousButton = false;
            scope.showFirstButton = false;
          } else {
            scope.showPreviousButton = true;
            scope.showFirstButton = true;
          }
          if (scope.pageIndex >= scope.totalPages) {
            scope.showNextButton = false;
            scope.showLastButton = false;
          } else {
            scope.showNextButton = true;
            scope.showLastButton = true;
          }
          // scope.lineErrors = response.data.errorCount;
          scope.prop65ComplianceItemsData = [];
          var mutableResponseRows = response.data.prop65MfTb;
          if (response.data.prop65MfTb.length > 0) {
            for (
              var i = 0, lineNumber = scope.minPageIndex;
              i < mutableResponseRows.length && lineNumber > 0;
              i++, lineNumber++
            ) {
              mutableResponseRows[i].lineNumber = lineNumber;
            }
            scope.prop65ComplianceItemsData = mutableResponseRows;
            sessionStorage.setItem(
              "prop65Rows",
              JSON.stringify(response.data.prop65MfTb)
            );
          } else {
            scope.prop65ComplianceItemsData = [];
            sessionStorage.removeItem("prop65Rows");
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          scope.isLoading = false;
          scope.$buefy.dialog.alert({
            message: `Failed to load MCS codes. Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            confirmText: "OK",
            type: "is-danger"
          });
        });
    },
    onRowClick: function(event) {
      var tableRows = event.target.closest("tr").parentElement.rows;
      for (var row in tableRows) {
        if (
          tableRows[row].classList &&
          tableRows[row].classList.contains("highlight-row")
        ) {
          tableRows[row].classList.remove("highlight-row");
        }
      }
      event.target.closest("tr").classList.add("highlight-row");
    },
    submitProp65() {
      var scope = this;
      var nameUser = window.$cookies.get("ni_key").nameUser;
      scope.isLoading = true;
      scope.$http
        .get(
          `${process.env.VUE_APP_API_BASE_DOMAIN}prop65/submitData?nameUser=${nameUser}`
        )
        // eslint-disable-next-line no-unused-vars
        .then(function(response) {
          scope.isLoading = false;
          scope.$buefy.dialog.alert({
            message: `Submitted Proposition 65 Compliance Errored item(s) successfully.`,
            confirmText: "OK",
            type: "is-success",
            onConfirm: () => scope.getProp65ComplianceItems()
          });
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          scope.isLoading = false;
          scope.$buefy.dialog.alert({
            message: `Failed to submit Proposition 65 Compliance Errored item(s). Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            confirmText: "OK",
            type: "is-danger"
          });
        });
    },
    updateProp65Items(index, requestPayload) {
      var scope = this;
      var args = {
        headers: {
          "content-type": "application/json"
        }
      };

      var updatedRowData = {};

      for (var key in requestPayload) {
        var prop = "";
        prop = requestPayload[key];
        if (typeof prop === "string") {
          if ((key === "mcs" && prop === "") || prop.trim() !== "") {
            updatedRowData[key] = requestPayload[key];
          }
        } else {
          updatedRowData[key] = requestPayload[key];
        }
      }

      scope.isLoading = true;
      scope.$http
        .put(
          `${process.env.VUE_APP_API_BASE_DOMAIN}prop65/updateMFProp65Data`,
          updatedRowData,
          args
        )
        // eslint-disable-next-line no-unused-vars
        .then(function(response) {
          scope.isLoading = false;
          var apiRow = response.data;
          apiRow.lineNumber = scope.prop65ComplianceItemsData[index].lineNumber;
          scope.prop65ComplianceItemsData[index] = apiRow;
          // scope.lineErrors = response.data.errorCount;
          var prop65Rows = JSON.parse(sessionStorage.getItem("prop65Rows"));
          prop65Rows.splice(index, 1, response.data);
          sessionStorage.setItem("prop65Rows", JSON.stringify(prop65Rows));
          //check errorCount for Submit
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          scope.isLoading = false;
          scope.$buefy.snackbar.open({
            duration: 5000,
            message: `Failed to update item. Please check for invalid data and/or clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            type: "is-danger",
            position: "is-top",
            queue: false
          });
        });
    },
    uploadProp65() {
      var scope = this;
      var networkId = window.$cookies.get("ni_key").networkId;
      var isUploadFormatValid = /^.*\.(xls|xlsx)$/.test(
        scope.prop65UploadFile.name
      );
      if (isUploadFormatValid) {
        scope.showValidationErrorMessage = false;
        scope.validationErrorDescription = "";
        var args = {
          headers: {
            "content-type": "multipart/form-data"
          }
        };
        var uploadData = new FormData();
        uploadData.append("file", scope.prop65UploadFile);
        scope.isLoading = true;
        scope.$http
          .post(
            `${process.env.VUE_APP_API_BASE_DOMAIN}prop65/uploadItems?networkId=${networkId}`,
            uploadData,
            args
          )
          .then(function(response) {
            scope.isLoading = false;
            scope.prop65UploadFile = null;
            if (response.data.toLowerCase() === "background") {
              scope.$buefy.dialog.alert({
                message: `File is being processed for upload in the background. You will be notified via email once it is complete.`,
                confirmText: "OK",
                type: "is-success",
                onConfirm: () => scope.getProp65ComplianceItems()
              });
            } else if (response.data.toLowerCase() === "failure") {
              scope.$buefy.dialog.alert({
                message: `A problem occurred with the upload file used. Please remove any special characters or extra line breaks on the description fields and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
                confirmText: "OK",
                type: "is-danger"
              });
            } else {
              scope.$buefy.dialog.alert({
                message: `Upload Successful for Proposition 65 Compliance Errored Items.`,
                confirmText: "OK",
                type: "is-success",
                onConfirm: () => scope.getProp65ComplianceItems()
              });
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch(function(error) {
            scope.isLoading = false;
            scope.$buefy.dialog.alert({
              message: `A problem occurred with the upload file used. Please remove any special characters or extra line breaks on the description fields and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
              confirmText: "OK",
              type: "is-danger"
            });
          });
      } else {
        scope.showValidationErrorMessage = true;
        scope.validationErrorDescription = `${scope.file.name} - Invalid file type, system accepts only .xls(x) extension.`;
      }
    }
  }
};
</script>

<style scoped></style>
